angular.module('lead')
    .factory('LeadSalesManagerConfigTime', function () {
        function toTimePickerValue(value) {
            if (!value) {
                return null;
            }
            if (moment.isMoment(value)) {
                return value.isValid() ? value.clone().seconds(0).milliseconds(0) : null;
            }
            if (angular.isDate(value)) {
                return moment(value).seconds(0).milliseconds(0);
            }
            const parsed = moment(String(value).trim(), ['HH:mm:ss', 'HH:mm'], true);
            return parsed.isValid() ? parsed : null;
        }

        function toApiTimeValue(value) {
            const parsed = toTimePickerValue(value);
            if (!parsed || !parsed.isValid()) {
                return null;
            }
            return parsed.clone().seconds(0).milliseconds(0).format('HH:mm:ss');
        }

        function formatTime(value) {
            const parsed = toTimePickerValue(value);
            return parsed ? parsed.format('HH:mm') : null;
        }

        return {
            toTimePickerValue: toTimePickerValue,
            toApiTimeValue: toApiTimeValue,
            formatTime: formatTime
        };
    })
    .factory('LeadSalesManagerCarouselStatus', function () {
        const labels = {
            ACTIVE: 'aktywna',
            DISABLED: 'wyłączona',
            USER_INACTIVE: 'użytkownik nieaktywny',
            MEETING_MODE: 'nie przydzielaj (spotkanie)',
            OUTSIDE_WORK_HOURS: 'poza godzinami',
            ON_LEAVE: 'absencja',
            ACTIVE_WAIT_LEAD_LIMIT_REACHED: 'limit osiągnięty'
        };
        const classes = {
            ACTIVE: 'label-success',
            DISABLED: 'label-danger',
            USER_INACTIVE: 'label-danger',
            MEETING_MODE: 'label-warning',
            OUTSIDE_WORK_HOURS: 'label-default',
            ON_LEAVE: 'label-warning',
            ACTIVE_WAIT_LEAD_LIMIT_REACHED: 'label-warning'
        };

        function status(item) {
            if (item && item.availabilityStatus) {
                return item.availabilityStatus;
            }
            if (!item || !item.active) {
                return 'DISABLED';
            }
            if (item.meetingMode) {
                return 'MEETING_MODE';
            }
            return item.availableInCarousel ? 'ACTIVE' : 'OUTSIDE_WORK_HOURS';
        }

        return {
            label: item => labels[status(item)] || 'poza dostępnością',
            className: item => classes[status(item)] || 'label-default'
        };
    })
    .factory('LeadSalesManagerConfigChange', function () {
        return {
            changedAt: change => change && change.changedAt ? moment(change.changedAt).format('DD.MM.YYYY HH:mm') : '-',
            changedBy: change => change && change.changedBy
                ? change.changedBy.fullName || change.changedBy.login || '-'
                : '-'
        };
    })
    .component('leadSalesManagerConfigList', {
        bindings: {
            items: '<'
        },
        templateUrl: 'app/lead/manager/sales-manager-config-list.html',
        controller: function (LeadSalesManagerConfig, LeadService, LeadSalesManagerConfigTime, LeadSalesManagerCarouselStatus, LeadSalesManagerConfigChange, toastr, modals) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.items = ctrl.items || [];
                ctrl.LeadService = LeadService;
            };

            ctrl.add = () => {
                const item = {
                    active: true,
                    meetingMode: false,
                    acceptsProjectlessLeads: true,
                    assignLeadsAfterHours: false,
                    smsNotificationsEnabled: true,
                    activeWaitLeadLimit: 15,
                    workStart: '09:00:00',
                    workEnd: '17:00:00',
                    projects: []
                };
                return ctrl.edit(item);
            };

            ctrl.edit = item => {
                return modals.open('app/lead/manager/sales-manager-config-edit-modal.html', 'LeadSalesManagerConfigEditController', angular.copy(item), {size: 'md'}, '$ctrl')
                    .then(saved => ctrl.upsert(saved));
            };

            ctrl.remove = item => {
                return modals.confirmDelete('konfigurację opiekuna sprzedaży', () => LeadSalesManagerConfig.remove({id: item.id}).$promise)
                    .then(() => {
                        ctrl.items = ctrl.items.filter(existing => existing.id !== item.id);
                        toastr.success('Usunięto konfigurację');
                    });
            };

            ctrl.upsert = item => {
                const index = ctrl.items.findIndex(existing => existing.id === item.id);
                if (index >= 0) {
                    ctrl.items[index] = item;
                } else {
                    ctrl.items.push(item);
                }
                ctrl.items.sort((a, b) => fullName(a).localeCompare(fullName(b)));
            };

            ctrl.formatTime = value => LeadSalesManagerConfigTime.formatTime(value);
            ctrl.carouselStatus = LeadSalesManagerCarouselStatus;
            ctrl.changedAt = LeadSalesManagerConfigChange.changedAt;
            ctrl.changedBy = LeadSalesManagerConfigChange.changedBy;

            function fullName(item) {
                return item && item.user ? item.user.fullName || item.user.login || '' : '';
            }
        }
    })
    .component('leadSalesManagerToolbar', {
        templateUrl: 'app/lead/manager/sales-manager-toolbar.html',
        controller: function (LeadSalesManagerConfig, LeadSalesManagerCarouselStatus, toastr, modals) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.loaded = false;
                LeadSalesManagerConfig.self().$promise
                    .then(item => {
                        ctrl.item = item && item.id ? item : null;
                        if (ctrl.item && ctrl.item.smsNotificationsEnabled === undefined) {
                            ctrl.item.smsNotificationsEnabled = true;
                        }
                    })
                    .finally(() => ctrl.loaded = true);
            };

            ctrl.hasConfig = () => !!(ctrl.item && ctrl.item.id);
            ctrl.carouselStatus = LeadSalesManagerCarouselStatus;
            ctrl.showSettings = () => {
                if (!ctrl.hasConfig()) {
                    return;
                }
                return modals.open('app/lead/manager/sales-manager-current-settings-modal.html', 'LeadSalesManagerCurrentSettingsController', {
                    item: ctrl.item
                }, {size: 'md'}, '$ctrl');
            };
            ctrl.toggle = field => {
                if (!ctrl.hasConfig()) {
                    return;
                }
                ctrl.item[field] = !ctrl.item[field];
                return ctrl.save(field);
            };
            ctrl.save = field => {
                const previous = !ctrl.item[field];
                const payload = {
                    meetingMode: ctrl.item.meetingMode,
                    assignLeadsAfterHours: ctrl.item.assignLeadsAfterHours,
                    smsNotificationsEnabled: ctrl.item.smsNotificationsEnabled
                };
                return LeadSalesManagerConfig.updateSelf(payload).$promise
                    .then(saved => {
                        ctrl.item = saved;
                        toastr.success('Zapisano ustawienia karuzeli leadów');
                    })
                    .catch(() => {
                        ctrl.item[field] = previous;
                    });
            };
        }
    })
    .controller('LeadSalesManagerCurrentSettingsController', function ($uibModalInstance, data, LeadSalesManagerConfigTime, LeadSalesManagerCarouselStatus, LeadSalesManagerConfigChange) {
        const ctrl = this;

        ctrl.$onInit = () => {
            ctrl.item = data.item;
        };

        ctrl.formatTime = value => LeadSalesManagerConfigTime.formatTime(value);
        ctrl.carouselStatus = LeadSalesManagerCarouselStatus;

        ctrl.changedAt = LeadSalesManagerConfigChange.changedAt;
        ctrl.changedBy = LeadSalesManagerConfigChange.changedBy;
        ctrl.close = () => $uibModalInstance.close();
    })
    .controller('LeadSalesManagerConfigEditController', function ($uibModalInstance, data, toastr, LeadSalesManagerConfig, LeadSalesManagerConfigTime) {
        const ctrl = this;

        ctrl.$onInit = () => {
            ctrl.item = angular.copy(data);
            if (ctrl.item.smsNotificationsEnabled === undefined) {
                ctrl.item.smsNotificationsEnabled = true;
            }
            if (ctrl.item.activeWaitLeadLimit === undefined) {
                ctrl.item.activeWaitLeadLimit = 15;
            }
            ctrl.item.assignLeadsAfterHours = !!ctrl.item.assignLeadsAfterHours;
            ctrl.item.workStart = LeadSalesManagerConfigTime.toTimePickerValue(ctrl.item.workStart);
            ctrl.item.workEnd = LeadSalesManagerConfigTime.toTimePickerValue(ctrl.item.workEnd);
        };

        ctrl.cancel = () => $uibModalInstance.dismiss('Canceled');

        ctrl.save = () => {
            if (!ctrl.hasValidWorkHours()) {
                toastr.error('Uzupełnij obie godziny pracy albo zostaw obie puste');
                return;
            }
            if (!ctrl.hasValidLeadLimits()) {
                toastr.error('Limity leadów muszą być nieujemnymi liczbami całkowitymi');
                return;
            }

            const payload = angular.copy(ctrl.item);
            payload.activeWaitLeadLimit = toLimit(payload.activeWaitLeadLimit);
            payload.workStart = LeadSalesManagerConfigTime.toApiTimeValue(ctrl.item.workStart);
            payload.workEnd = LeadSalesManagerConfigTime.toApiTimeValue(ctrl.item.workEnd);

            const request = payload.id
                ? LeadSalesManagerConfig.update({id: payload.id}, payload).$promise
                : LeadSalesManagerConfig.save(payload).$promise;

            return request.then(saved => {
                toastr.success('Zapisano konfigurację opiekuna sprzedaży');
                $uibModalInstance.close(saved);
            });
        };

        ctrl.hasValidWorkHours = () => {
            const hasStart = !!LeadSalesManagerConfigTime.toTimePickerValue(ctrl.item.workStart);
            const hasEnd = !!LeadSalesManagerConfigTime.toTimePickerValue(ctrl.item.workEnd);
            return hasStart === hasEnd;
        };

        ctrl.hasValidLeadLimits = () => isValidLimit(ctrl.item.activeWaitLeadLimit);

        function toLimit(value) {
            return value === '' || value == null ? null : Number(value);
        }

        function isValidLimit(value) {
            return value === '' || value == null || (Number(value) >= 0 && Number(value) % 1 === 0);
        }
    });
